var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMHat3WHair1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "w-hair1_5_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D0E09B",
    d: "M571.5,152.9c1.7-30.1-8.9-59.9-27.9-83c-101.4-81.7-226.2-85.5-328-15.3c-74,51-132,146-97,195 c0.5,2.6,12.9,12.6,15.3,15.7c26.7,17.6,57.2-8.2,76-24.7c10.9-9.6,26.8-27.9,38.7-36c18.9-13,90.3-15.2,111-12.5l56,2 c0.9,0.7,57.6,2.7,58.5,3.5c20,18,28.5,55.7,29.4,70.6c6.1-16,18.8-29.1,34-39.4c12.6-13,22.2-28.8,27.9-45.8 C568.7,173.2,570.8,163,571.5,152.9z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "hats_w-hair1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m-hat3_1_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6F3C1B",
    d: "M527.7,158.1c-1.2-17.9-32.5-18.2-46.3-19.2c-40.3-2.8-79.6,4.6-120.8,4.3c-28.9-0.2-59.6-3.2-91-5.9 l-3.7-0.5c-12.3-1.8-34.2,1.1-46.8,4.3c-14.7,3.7-35,14.5-23.9,33c7.1,11.9,30.7,26.3,43.1,31.4c16.6,6.8,29.4,11.2,46.8,15.3 c34.8,8.1,70.9,5,105.9,0.7c35.7-4.4,70.4-12,103.3-28.6C507,186.4,528.8,175.2,527.7,158.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6F3C1B",
    d: "M438.4,81.7c-9.5-4.8-21.5-7.5-31.2-11.7c-10-4.4-15.3-12.6-24.9-18.4c-20.8-12.4-50.9,2.8-68.7,14.8 c-22.7,15.3-37.9,5.1-53.2,24.5c-7.4,9.3-8.2,23.2-8.5,34.8c-0.2,7.1,0.4,18.7,1.2,29.2c1.4,0.9,2.7,1.8,4.1,2.6 c54.5,32.6,126.8,35.8,185.7,10.2c5.7-2.6,11.2-5.5,16.6-8.7c1.4-0.8,2.7-1.7,4.1-2.5c-0.2-4.4-0.4-8.4-0.6-11.2 C460.7,121.4,463.3,94.2,438.4,81.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#CCB37F",
    d: "M461.4,124.2c-0.9,0.4-1.7,0.8-2.6,1.2c-5.6,2.5-11.2,4.8-17,6.9c-56.8,19.4-120.7,18.4-176-4.5 c-4.7-2-9.3-4.1-13.8-6.3c-0.1,1.4-0.1,2.7-0.1,4.1c-0.2,7.1,0.4,18.7,1.2,29.2c1.4,0.9,2.7,1.8,4.1,2.6 c54.5,32.6,126.8,35.8,185.7,10.2c5.7-2.6,11.2-5.5,16.6-8.7c1.4-0.8,2.7-1.7,4.1-2.5c-0.2-4.4-0.4-8.4-0.6-11.2 C462.3,138.3,462.1,131.2,461.4,124.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#41210D",
    d: "M361.7,102.8c20.6-3.2,34.7-16.9,47-32.2c-0.5-0.2-1-0.4-1.4-0.6c-10-4.4-15.3-12.6-24.9-18.4 c-20.8-12.4-50.9,2.8-68.7,14.8c-3.9,2.7-7.7,4.6-11.2,6c1.2,2.2,2.5,4.3,4,6.3C318,96.4,340.4,106,361.7,102.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#41210D",
    d: "M463.6,156.4c-0.2-4.4-0.4-8.4-0.6-11.2c-1.9-21-0.2-44.6-16.8-58.5c-5.7,25.7,0.7,51.9,3.7,77.5 c3.3-1.7,6.5-3.5,9.7-5.4C460.9,158.1,462.2,157.2,463.6,156.4z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#41210D",
    d: "M285,107.1c38.3,23.5,94.7,24.5,132-2.1c-12.8,25.5-53,28.9-78.6,26.8C316.1,129.6,302.1,123,285,107.1"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFE7B6",
    d: "M329.3,144.2c-7.1,11.1-12.8,21-22.5,33.8c3.5,0.9,7.1,1.7,10.7,2.4c10.2-13.3,15.8-23.5,23.4-35.1 C336.9,145,333.1,144.7,329.3,144.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFE7B6",
    d: "M376.2,145.4c-8.5,12.7-18.3,27.4-28.3,38.9c14.6,0.8,29.4,0.1,43.8-2.1c8.6-13,16.6-28.9,23.6-42.4 C402.5,142.7,389.4,144.6,376.2,145.4z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMHat3WHair1);
export default __webpack_public_path__ + "static/media/m-hat3_w-hair1.992806a89481fe35b80103a0e179f5bb.svg";
export { ForwardRef as ReactComponent };